import React from "react";

import DevModeGuard from "@guards/DevModeGuard/DevModeGuard";

import "./Debug.scss";

const Debug = () => {
  return (
    <div className="debug-page">
      <h2>Debug page</h2>

      <div className="debug-page-content">Lorem ipsum</div>
    </div>
  );
};

export default (
  <DevModeGuard>
    <Debug />
  </DevModeGuard>
);
